module.exports = __webpack_public_path__ + "static/media/youtube_page_preview.05793c78.png";